function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycleBinModern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "recycle_bin_modern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "M6.139 1.611a3.34 3.34 0 0 1 5.715 0l1.357 2.2.949-.557a.83.83 0 0 1 .935.061.868.868 0 0 1 .3.9l-.822 3.121a.844.844 0 0 1-1.033.607l-3.072-.836a.86.86 0 0 1-.2-1.568l1-.586-1.322-2.132a1.109 1.109 0 0 0-1.9 0l-.615 1A1.113 1.113 0 0 1 5.9 4.2a1.154 1.154 0 0 1-.376-1.586zM15.1 9a1.113 1.113 0 0 1 1.533.375l.858 1.4A3.5 3.5 0 0 1 18 12.56 3.4 3.4 0 0 1 14.631 16h-3.385v1.143a.856.856 0 0 1-.52.793.835.835 0 0 1-.921-.186l-2.25-2.286a.863.863 0 0 1 0-1.211l2.25-2.286a.835.835 0 0 1 .921-.186.856.856 0 0 1 .52.793v1.143h3.381a1.129 1.129 0 0 0 1.118-1.143 1.149 1.149 0 0 0-.169-.6l-.858-1.4A1.151 1.151 0 0 1 15.1 9zM2.28 7.889l-1.016-.6a.861.861 0 0 1-.415-.854.852.852 0 0 1 .619-.714l3.072-.832a.844.844 0 0 1 1.033.611L6.4 8.614a.87.87 0 0 1-.3.9.823.823 0 0 1-.935.061l-.931-.546-1.81 2.943a1.149 1.149 0 0 0-.169.6 1.129 1.129 0 0 0 1.118 1.143H4.5A1.143 1.143 0 0 1 4.5 16H3.366A3.4 3.4 0 0 1 0 12.556a3.432 3.432 0 0 1 .513-1.793L2.28 7.889z",
    transform: "translate(3.002 4)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleBinModern);
export default __webpack_public_path__ + "static/media/recycle_bin_modern.e97bd8090d98e0523aae05843c70f306.svg";
export { ForwardRef as ReactComponent };